module.exports = __webpack_public_path__ + "assets/TikTok-minimal.6937240a.svg";